import script from "./HeaderProjectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderProjectMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderProjectMenu.vue?vue&type=style&index=0&id=d6b86aa0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6b86aa0"]])

export default __exports__